<template>
  <div class="products-table" id="products-table"
    :class="{ hiddenProductsTable: !show, smallMarginTop: this.smallMarginTop }">
    <div class="titles-area">

      <h2 :class="[this.title.class]">{{ this.title.title }}</h2>

      <div class="specifications-area">
        <div v-for="(value, key) in mapping" :key="key">
          <div class="specification-title" :class="{ open: visible[key] }" v-on:click="toggleVisible(key)">
            <h3>{{ value.name }}
              <ChevronDownIcon class="chevron" />
            </h3>
          </div>
          <LeftIndex v-for="spec in value.specs" :key="spec" :spec="spec" :section="key" :visible="visible"
            :highlights="highlights" />
        </div>
      </div>
    </div>

    <!-- CAROUSEL DESKTOP -->
    <div class="table-area table-area-desktop">
      <div class="btn-carousel">
        <button v-if="show == true" class="slick-arrow previous" @click="carouselprevious"></button>
        <button v-if="show == true" class="slick-arrow" @click="carouselNext"></button>
      </div>
      <CarouselTableProducts ref="carousel" :key="componentKey" v-bind="settings" @init="isButtons"
        @afterChange="ChangeNext">
        <div v-for="(product) in products" :key="product.sku" class="item">
          <CardTV :key="product.sku" :product="product" :indication="false" :costBenefit="false"
            @onClickOpenForm="onClickOpenForm" :idCardTV="idCardTV" :perfectForYou="product.perfectForYou"
            :bestCostBenefit="product.bestCostBenefit" :visibleSections="visible" :highlights="highlights"
            :goSmooth="goSmooth" :menuActive="menuActive" :showOverview="showOverview" />
        </div>
      </CarouselTableProducts>
    </div>

  </div>
</template>

<script>
import CardTV from "../components/CardTV.vue";
import LeftIndex from "../components/LeftIndex.vue";
import ChevronDownIcon from '../assets/chevron-down.svg'
import specs, { mapping } from "../constants/specs";

//https://gs-shop.github.io/vue-slick-carousel/#/example/simple
import CarouselTableProducts from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  name: "ProductsTable",
  components: { CardTV, LeftIndex, ChevronDownIcon, CarouselTableProducts },
  props: [
    "sendAnalytics",
    "products",
    "title",
    "show",
    "menuActive",
    "highlights",
    "goSmooth",
    "smallMarginTop",
    "showOverview",
    "userChoices",
  ],
  data() {

    return {
      componentKey: 0,
      carouselStart: true,
      specs,
      mapping,
      idCardTV: 0,
      pristine: true,
      visible: {
        design: true,
        image: false,
        gaming: true,
        sound: false,
        connectivity: true,
      },
      settings: {
        "arrows": false,
        "dots": false,
        "speed": 500,
        "slidesToShow": 5,
        "infinite": false,
        "slidesToScroll": 4,
        "touchThreshold": 5,
        "variableWidth": false,
        "swipe": true,
        "responsive": [
          {
            "breakpoint": 470,
            "settings": {
              "variableWidth": true,
              "speed": 100,
              "swipeToSlide": true,
              "edgeFriction": 0.10,
              "slidesToShow": 1,
              "slidesToScroll": 1,
              "centerMode": false,
            }
          },
          {
            "breakpoint": 565,
            "settings": {
              "variableWidth": true,
              "speed": 100,
              "swipeToSlide": true,
              "edgeFriction": 0.10,
              "slidesToShow": 1,
              "slidesToScroll": 1,
              "centerMode": false,
            }
          },
          {
            "breakpoint": 620,
            "settings": {
              "slidesToShow": 3,
              "slidesToScroll": 5,
              "touchThreshold": 5,
              "centerMode": false,
              "swipeToSlide": true,
            }
          },
          {
            "breakpoint": 991,
            "settings": {
              "slidesToShow": 3,
              "slidesToScroll": 3,
              "swipeToSlide": true,
            }
          },
          {
            "breakpoint": 1276,
            "settings": {
              "slidesToShow": 4,
              "slidesToScroll": 4,
              "swipeToSlide": true,
            }
          }
        ]
      }
    }
  },
  watch: {
    products: {
      handler() {
        this.forceRerender()
        this.$refs.carousel.goTo(0)
        this.idCardTV += 1;

        if (this.userChoices == "todos") {
          this.visible.design = false
          this.pristine = false
          return;
        }

        if (this.idCardTV > 1 && this.pristine) {
          Object.keys(this.visible).forEach((key) => this.visible[key] = false);
        }

      }
    }
  },
  methods: {
    forceRerender() {
      this.componentKey += 1;
    },
    onClickOpenForm(selectedTv) {
      this.$emit("onClickOpenForm", selectedTv);
    },
    handleIdCardTV() {
      this.idCardTV += 1;
      return this.idCardTV;
    },
    toggleVisible(section) {
      this.pristine = false;
      this.visible[section] = !this.visible[section];
    },

    carouselprevious() {
      this.$refs.carousel.prev()
    },
    carouselNext() {
      this.$refs.carousel.next()
    },
    ChangeNext(SliderNumber) {

      const slickTrack = document.querySelectorAll(".slick-track")
      const lastElemen = slickTrack[0].lastElementChild
      const isClass = lastElemen.classList.contains("slick-active")

      if (isClass) {
        document.querySelectorAll(".slick-arrow ~ .slick-arrow")[0].classList.add("disabled")
      } else {
        document.querySelectorAll(".slick-arrow ~ .slick-arrow")[0].classList.remove("disabled")
      }
      if (SliderNumber == 0) {
        document.querySelectorAll(".table-area .previous")[0].classList.add("disabled")
      } else {
        document.querySelectorAll(".table-area .previous")[0].classList.add("active")
        document.querySelectorAll(".table-area .previous")[0].classList.remove("disabled")
      }
    },
    isButtons() {

      const slickTrack = document.querySelectorAll(".slick-track")
      const lastElemen = slickTrack[0].lastElementChild
      const isClass = lastElemen.classList.contains("slick-active")

      if (isClass) {
        document.querySelectorAll(".slick-arrow ~ .slick-arrow")[0].classList.add("disabled")
      } else {
        document.querySelectorAll(".slick-arrow ~ .slick-arrow")[0].classList.remove("disabled")
      }


    }
  },
  computed: {},
  mounted() {

    function setTableTranslate() {
      const btnCarousel = document.querySelector(".btn-carousel")
      const tableAreaWidth = document.querySelector(".table-area").clientWidth
      const tableAreaOverlay = document.querySelector(".titles-area")
      const rect = document.querySelector('.table-area').getBoundingClientRect();
      const initialTop = scrollY + rect.top;

      btnCarousel.style.width = `${tableAreaWidth}px`

      // const windowScrollY = window.scrollY
      // const initialBottom = scrollY + rect.bottom;
      // const headerOverlay = document.getElementById('body-card-tv-fixed')
      // const reactHeader = headerOverlay.getBoundingClientRect()
      // const headerHeigth = reactHeader.height.toFixed(0)
      // const scrollYOlverlay = reactHeader.top.toFixed(0) + windowScrollY.toFixed(0)
      // const offset = (headerHeigth - initialBottom) * -1

      if (window.scrollY >= initialTop) {
        btnCarousel.classList.add("fixed");
        tableAreaOverlay.classList.add("overlaySidebarFixed")
      } else {
        btnCarousel.classList.remove("fixed");
        tableAreaOverlay.classList.remove("overlaySidebarFixed")
      }

      // Foi utilizado o .toFidex(0) para remover as casas decimais que causavam um bug impedindo
      // de funcionar direito

      if (rect.bottom.toFixed(0) <= 370) {
        btnCarousel.classList.add("fixedStop")
        tableAreaOverlay.classList.add("fixedStop")
      }
      else {
        btnCarousel.classList.remove("fixedStop")
        tableAreaOverlay.classList.remove("fixedStop")
      }

      // if(windowScrollY < scrollYOlverlay){

      //   btnCarousel.classList.remove("fixedStop")
      // }

    }


    window.addEventListener('scroll', () => {

      setTableTranslate()
    });

  }
};
</script>

<style lang="scss">
@import "../sass/main.scss";

.specifications-area {
  transform: translateY(35px);
}

.slick-list {
  contain: paint;
  overflow: initial !important;
  cursor: pointer;
}

.slick-list .card-tv {
  width: 97%;
}

.hiddenProductsTable {
  display: none !important;
}

.table-area.table-area-mobile {
  display: none;
}

.header-overlay-mobile .table-area.table-area-mobile {
  padding-bottom: 0;
}

.carousel-header-overlay,
.header-overlay-mobile {
  z-index: -1;
  position: absolute;
  top: 0;
  background-color: #f7f3f0;

  .separator-wrapper {
    display: none;
  }

  .footer-card-tv {
    display: none;
  }
}

.header-overlay-mobile {
  width: 100%;
  top: 71px;

}

.btn-carousel {
  top: 0;
  min-height: 370px;
  position: absolute;
  width: 100%;
  z-index: 3;
}

.btn-carousel.fixed,
.header-overlay-mobile.fixed {
  position: fixed;
  z-index: 2;
}

div.slick-slider.slick-initialized {
  z-index: 3;
  position: relative;
}

.header-overlay-mobile.fixed {
  top: 0;
}

.table-area:has(.carousel-header-overlay.fixed)>button {
  display: none;
}

.carousel-header-overlay.fixed.fixedStop,
.header-overlay-mobile.fixed.fixedStop {
  position: absolute;
  bottom: 0;
  top: initial;
}

.btn-carousel.fixed.fixedStop {
  position: absolute;
  z-index: 4;
  bottom: 0;
  top: initial;
}

.slick-arrow {
  background-color: #D7D2CB;
  border-radius: 60px 2px 2px 60px;
  width: 40.03px;
  height: 40px;
  text-align: center;
  display: block;
  transform: translateX(-44px);
  top: 1px;
  display: flex;
  justify-content: center;
  align-items: center;
  float: left;

  &::before {
    content: "";
    display: block;
    background-image: url("./../assets/arrowTable.png");
    background-position: center;
    background-repeat: no-repeat;
    color: transparent;
    opacity: initial;
    width: 16px;
    height: 18px;
  }

  &:hover,
  &:focus {
    background-color: #D7D2CB;
  }
}

.slick-arrow~.slick-arrow {
  left: initial;
  top: 1px;
  transform: translateX(43px) rotate(180deg);
  float: right;
}

.slick-arrow.previous {
  opacity: .25;
}

.slick-arrow.active {
  opacity: initial;
}

.slick-arrow.disabled {
  opacity: .25;
}

.slick-arrow.previous.disabled {
  opacity: .25;
}

.header-overlay-mobile .table-area.table-area-mobile::-webkit-scrollbar {
  width: 0;
  background: transparent;
  height: 0;
  border: none;
}

.header-overlay-mobile .table-area.table-area-mobile::-webkit-scrollbar-track {
  width: 0;
  background: transparent;
  height: 0;
  border: none;
}

.header-overlay-mobile .table-area.table-area-mobile::-webkit-scrollbar-thumb {
  width: 0;
  background: transparent;
  height: 0;
  border: none;
}

.specifications-area {
  .specification-title {
    h3 {
      display: flex;
      align-items: center;
      font-size: 16px;
      font-family: 'SamsungOneBold', sans-serif;
      color: $color-gray-extra-dark;
    }
  }

  .specification {
    display: flex;
    align-items: center;
    gap: 2px;
  }

  .specification-title,
  .specification {
    font-size: 15px;
    width: 100%;
    line-height: 50px;
    width: 185px;
  }
}

.titles-area {
  max-width: 215px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding-bottom: 32px;
  padding-left: 1.3rem;
  position: relative;

  &::before {
    content: "";
    display: block;
    width: 200px;
    height: 370px;
    background: #f7f3f0;
    position: fixed;
    top: 0;
    display: none;
    z-index: 2;
  }

  &.overlaySidebarFixed::before {
    display: block;
  }

  &.overlaySidebarFixed.fixedStop::before {
    position: absolute;
    bottom: 0;
    top: initial
  }
}

.products-table {
  display: flex;

  background-color: #f7f3f0;

  padding: 2.5rem 0;
  // margin-top: 4.5rem;

  width: 100%;
  max-width: 1311px;

  border-radius: 1rem;

  h2 {
    // max-width: 100px;

    font-family: $font-family-default-bold;
    font-size: 1.4rem;
    line-height: 2rem;
    color: #2e2c2b;
    padding-right: 4rem;
    position: relative;
    z-index: 3;
  }


  .table-area {
    position: relative;
    width: 100%;
    max-width: 1045px;
  }

  .table-area::-webkit-scrollbar {
    background-color: #f7f3f0;
    height: 6px;
  }

  .table-area::-webkit-scrollbar-thumb {
    background: $color-dark-default;
    border-radius: 4px;
  }
}

.smallMarginTop {
  margin-top: 0;
  border-radius: 0;
}

@media (max-width:1320px) {
  .products-table .table-area {
    max-width: calc(78% - 60px);

    .item {
      padding: 0 5px;
    }

    .card-tv {
      width: 100%;
    }
  }

}

@media (max-width:991px) {
  .products-table .table-area {
    max-width: calc(78% - 80px);
  }

}

@media (max-width: $bp-mobile) {
  .titles-area {
    &::before {
      display: none;
    }

    &.overlaySidebarFixed::before {
      display: none;
    }

    &.overlaySidebarFixed.fixedStop::before {
      display: none;
    }
  }

  .btn-carousel {
    display: none;
  }

  .titles-area {
    max-width: unset;
    padding-bottom: 1rem;

    h2 {
      text-align: left;
    }
  }

  .specifications-area {
    display: none;
  }

  .products-table {
    margin: 0;
    flex-direction: column;
    padding: 1.25rem 0;
    position: relative;

    h2 {
      min-width: 130px;
      padding-right: 2rem;
    }
  }

  /* .smallMarginTop{
    margin-top: 3rem;
  } */

  .item:first-child {
    margin-left: 1.3rem;
  }

  .item:last-child {
    margin-right: 1.3rem;
  }

  .products-table .table-area {
    max-width: initial;
    padding-left: 1.3rem;
  }

  .table-area-desktop {
    /* display: none; */
  }

  .slick-arrow {
    display: none;
  }

  .slick-list .item:last-child {
    margin: 0;
  }

  .slick-list .item:first-child {
    margin: 0;
  }

  .products-table .table-area .card-tv {
    width: 204px;
  }

  .table-area.table-area-mobile {
    display: none;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    gap: 0.5rem;
    overflow-x: scroll;
    padding-bottom: 1.5rem;
  }

  .products-table .table-area .item {
    padding: 0;
  }

  div.slick-slide {
    padding: 0 2px;
  }
}

@media (max-width: 430px) {
  .products-table .table-area {
    gap: 0.3rem;
  }

  .item:first-child {
    margin-left: .85rem;
  }

  .item:last-child {
    margin-right: .85rem;
  }
}

div.slick-list {
  padding: 0 !important;
}

.inactive {
  display: none !important;
}

.chevron {
  margin-left: 8px;
  transition-duration: 0.3s;
  transition-property: transform;
}

.open {
  .chevron {
    transform: rotate(180deg);
  }
}
</style>
